import React from 'react';
import { styles } from './RateLimitError.css';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { Link } from '../../PlatformFunctionality';

export type RateLimitErrorProps = { contactUsUrl: string };

export const RateLimitError = ({ contactUsUrl }: RateLimitErrorProps) => {
  return (
    <div className={styles.container}>
      <Icon name="BatteryAlertIllustrated" width={100} height="auto" />
      <h3>Tracking limit reached ...</h3>
      <p>Looks like you’ve tried to access our tracking tool too many times.</p>
      <p>
        Not a robot?&nbsp;
        <Link href={contactUsUrl} className={styles.contactUsLink}>
          Contact us
        </Link>
      </p>
    </div>
  );
};
